module.exports = ".share {\n  font-family: OpenSans;\n  font-size: 12px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #404040;\n}\n\n.sign-other {\n  margin-top: 15px;\n  margin-bottom: 30px;\n}\n\n.sign-other ul {\n  margin-top: 5px\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/myprofile/certificate/certificate.component.css
// module id = ./src/app/myprofile/certificate/certificate.component.css
// module chunks = main